<tam-dialog [opened]="opened" [dialogWidth]="dialogWidth">
    <ng-template #title>
        <div class="item-header">
            <div class="dialog-close">
                <smart-icon class="dark" name="close" (click)="close($event)"></smart-icon>
            </div>
        </div>
    </ng-template>
    <ng-template #body>
        <div loading-spin [isLoading]="loading" [loadingSize]="'big'" class="dialog-body">
            <tam-html-container *ngIf="!loading" #htmlContent [html]="content"></tam-html-container>
        </div>
    </ng-template>
    <ng-template #footer>
        <button tam-button [tamType]="'primary'" [tamSize]="'normal'" (click)="print($event)">Print</button>
    </ng-template>
</tam-dialog>>